<template>
  <div>
    <el-upload :action="action" :headers="headers" :data="up_path" :multiple="mul" ref="uploadMutiple"
      :file-list="fileList" :limit="limit" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess"
      :on-change="handleAvatarChange" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :accept="acc">
      <el-button size="mini" type="primary">{{ name }}</el-button>
      <div slot="tip" class="el-upload__tip" style="color: #909399; margin-top: 0.2rem">
        单次上传最多{{ many }}个文件或图片
      </div>
    </el-upload>
    <div style="margin-top: 0.2rem">
      <span><i class="el-icon-s-opportunity" style="color: #fb894c">点击下方，Ctrl+v上传</i></span>
    </div>
    <div id="preview" @paste="handlePaste" style="
           border: 3px dashed #409eff;
            border-radius: 15px;
              text-indent: 2em;
              height: 45px;
              text-align: center;
              line-height: 45px;
              ">
      <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpFile',
  props: ['many', 'name', 'action', 'mul', 'bus', 'acc', 'acce', 'size_M', 'err_bus', 'up_path'],
  data() {
    return {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      dialogVisible: false,
      dialogImageUrl: '',
      change: false,
      fileList: [],
      limit: this.many,
      needUrl: [],
    }
  },
  methods: {
    // 修改或2个上传组件可以共用before
    beforeAvatarUpload(file) {
      console.log(file.type)
      let arr = []
      let type_str = ''
      if (this.acce.indexOf('img') !== -1) {
        arr.push(
          // 'image/jpeg',
          // 'image/jpg',
          // 'image/png',
          // 'image/gif',
          // 'image/bmp',
          'image/'
        )
        type_str += '图片,'
      }

      if (this.acce.indexOf('pdf') !== -1) {
        arr.push('application/pdf')
        type_str += 'pdf,'
      }

      if (this.acce.indexOf('voice') !== -1) {
        arr.push('audio/')
        type_str += '音频,'
      }

      if (this.acce.indexOf('video') !== -1) {
        arr.push('video/')
        type_str += '视频,'
      }

      if (this.acce.indexOf('excel') !== -1) {
        arr.push('application/vnd.ms-excel')
        arr.push('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        type_str += 'xls/xlsx,'
      }

      if (this.acce.indexOf('doc') !== -1) {
        arr.push('application/msword')
        arr.push('application/vnd.openxmlformats-officedocument.wordprocessingml.document')
        type_str += 'doc/docx,'
      }

      if (this.acce.indexOf('ppt') !== -1) {
        arr.push('application/vnd.ms-powerpoint')
        type_str += 'ppt,'
      }

      if (this.acce.indexOf('text') !== -1) {
        arr.push('text/plain')
        type_str += 'txt/xml,'
      }

      if (this.acce.indexOf('tar') !== -1) {
        arr.push('application/x-tar')
        type_str += 'tar,'
      }

      if (this.acce.indexOf('zip') !== -1) {
        arr.push('application/x-zip-compressed')
        arr.push('application/zip')
        type_str += 'zip,'
      }

      if (this.acce.indexOf('wps') !== -1) {
        arr.push('application/vnd.ms-works')
        type_str += 'wps,'
      }

      if (arr.length > 0) {
        let fileType_common_index = file.type.indexOf('/') + 1
        let fileType_common = file.type.substr(0, fileType_common_index)
        if (arr.indexOf(file.type) == -1) {
          if (arr.indexOf(fileType_common) == -1) {
            type_str = type_str.substring(0, type_str.length - 1)
            this.$message.error('只能上传' + type_str + '格式的文件!')
            // this.$bus.$emit(this.err_bus, '只能上传' + type_str + '格式的文件!')
            return false
          }
        }
      }

      // if (this.acce.indexOf('img') !== -1 && this.acce.indexOf('pdf') !== -1) {
      //   let arr = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']
      //   if (arr.indexOf(file.type) == -1) {
      //     this.$message.error('只能上传图片或pdf!')
      //     return false
      //   }
      // }
      // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      var isLt100M = 0
      if (this.size_M) {
        isLt100M = file.size / 1024 / 1024 < this.size_M
      } else {
        isLt100M = file.size / 1024 / 1024 < 100
      }
      // if (!isJPG) {
      //   this.$message.error('上传图片格式为JPG或PNG!')
      //   return
      // }
      if (!isLt100M) {
        // this.$bus.$emit(
        //   this.err_bus,
        //   !this.size_M
        //     ? '上传总大小不能超过 100MB!'
        //     : '上传总大小不能超过' + this.size_M + 'MB!'
        // )
        this.$message.error(
          !this.size_M
            ? '上传总大小不能超过 100MB!'
            : '上传总大小不能超过' + this.size_M + 'MB!'
        )
        return false
      }
      // return isJPG && isLt2M
    },
    // 成功方法2个组件不可共用，修改可共用但要清空
    handleAvatarSuccess(res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid })
      }
      this.$bus.$emit(this.bus, this.needUrl)
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    // 成功方法2个组件不可共用，修改可共用但要清空
    handleAvatarChange(res, file) {
      this.fileList = file
      this.change = true
      this.$bus.$emit(this.bus, this.needUrl)
    },
    // 修改或2个上传组件可以共用
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 成功方法2个组件不可共用，修改可共用但要清空
    handleRemove(file, fileList) {
      // 这是删除服务器上的文件，需要的话自行打开
      // this.axios.get('api/pay/del_pic?file=' + file.response.url).then(({data}) => {
      // }).catch()
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1)
        }
      })
      this.fileList = fileList
      this.change = true
      this.$bus.$emit(this.bus, this.needUrl)
    },
    // 成功方法2个组件不可共用，修改可共用但要清空
    // 监听粘贴操作
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        // if (items[i].type.indexOf('image') !== -1) {
        file = items[i].getAsFile()
        // break
        // }
      }
      // if (!file) {
      //   this.$message.error('粘贴内容非图片')
      //   return
      // }
      if (this.fileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`) // 图片数量超出
        return
      }
      this.$refs.uploadMutiple.handleStart(file) // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit() // 提交图片上传队列
    },
  },
  mounted() {
    this.$bus.$on('ysyclearrm', () => {
      this.fileList = []
      this.needUrl = []
      this.change = false
    })
  },
  beforeCreate() {
    this.$bus.$off('ysyclearrm')
  },
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/common/UpFile.vue